module.exports = __webpack_public_path__ + "img/globalvisaadvisor.c6aa831a.png";